import { render } from 'preact';
import { App } from './App';
import './styles/main.css';
import './lib/theme';       // initializes the theme effect on import
import './lib/api';         // initializes the dashboard token cache from URL
import { startChatStream } from './lib/chat-stream';
import { TEACHER } from './lib/teacher-mode';

// Single chat SSE for the lifetime of the page. Any view subscribes and
// the sidebar reads the unread count from the same signal.
if (!TEACHER) startChatStream();

const root = document.getElementById('app');
if (root) {
  render(<App />, root);
}
